import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import XMLParser from 'react-xml-parser';
// import axios from 'axios';

// STYLES
import styles from '../../../Styles/ComponentStyles/MainPages/dashboard.module.scss'
import globalStyles from '../../../Styles/global.module.scss'
import '../../../Styles/ComponentStyles/MainPages/TradingView.css'

// MUI
import Grid from '@mui/material/Grid2';
import { Avatar, Dialog, Divider, Skeleton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { tabsConfig, keyIndicesTabs, keyIndicesData, baseURL, capitalize, useIsBelow1200, useIsBelow600 } from '../../../Utils/Constant/Constant';

// IMG
import varifiedLogo from '../../../Assets/Dashboard/dash-varified-secure-logo.png';
import lifebrain from '../../../Assets/Dashboard/lifebrain-bg.png'

// GLOBAL
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import Icons from '../../../Utils/Layout/Icons/Icons';
import AppNavbar from '../../../Components/AppNavbar/AppNavbar';
import FeaturedCards from '../../../Components/FeaturedCards/FeaturedCards';
import ComplianceDocument from '../../../Components/ComplianceDocument/ComplianceDocument';
import StocksMarquee from '../../../Components/StocksMarquee/StocksMarquee';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
// import DashboardNavbar from '../DashboardNavbar/DashboardNavbar';
// import GlobalTabs from '../../../Utils/Layout/GlobalTabs/GlobalTabs';
// import KeyIndices from '../../../Components/KeyIndices/KeyIndices';
// import AppStores from '../../../Components/Dialogs/AppStores';
// import AdminAppNavbar from '../../../Components/AdminAppNavbar/AdminAppNavbar';

// DIALOG
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import PortfolioDialog from '../../../Components/Dialogs/PortfolioDialog';
import KeyIndecesDialog from '../../../Components/Dialogs/KeyIndicesDialog';
import AppClientMarketingDialog from '../../../Components/Dialogs/AppClientMarketingDialog';
import CredentialsDialog from '../../../Components/Dialogs/CredentialsDialog';
import ClientMarketingAndCorrespondenceDialog from '../../../Components/Dialogs/ClientMarketingAndCorrespondenceDialog';
// import SsoDialog from '../../../Components/Dialogs/SsoDialog';
// import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';

// CONTEXT & API
import agent from '../../../Services/api';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import { DashboardContext, DashboardDetailPayload } from '../../../Context/DashboardDetailContext';
import { AppAccessRequestInterface, AppsOrderPayload } from '../../../models/dashboardAxiosModels';
import AcrylicTeamProfilelist from '../DashboardCommonComponents/AcrylicTeamProfilelist';


export default function DashoboardHome() {


    const {
        setFlagLoader,
        userProfileDetails,
        isAdminNavbarVisible,
        userDetails,
        setUserProfileDetails,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const {
        dashboardDetails,
        setDashboardDetails,
        storedColorthemeOptions,

        storedDisplayMode,
        setSelectedStocks,
        setTickerSaveDetails,
        setTickerSaveDetailsDsh
    } = useContext(DashboardContext) as DashboardDetailPayload

    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate()

    // CONST
    const isProfileAdmin = userProfileDetails?.user?.flagAdmin
    const isBelow600 = useIsBelow600()
    const isBelow1200 = useIsBelow1200();
    const containerRef = useRef<HTMLDivElement>(null);
    const dragItem = useRef<number | null>(null);
    const dragOverItem = useRef<number | null>(null);
    const previousAppsData = useRef<any>(null);

    // DIALOG FLAGS
    const [accessDialog, setFlagAccessDialog] = useState(false);
    const [flagInstallAccessDialog, setFlagInstallAccessDialog] = useState(false);
    const [flagPortfolioDialog, setFlagPortfolioDialog] = useState(false);
    const [flagAppStoreDialog, setFlagAppStoreDialog] = useState(false);
    const [flagClientMarketingDialog, setFlagClientMarketingDialog] = useState<boolean | null>(false);
    const [flagOpenKeyIndeciesDialog, setFlagOpenKeyIndeciesDialog] = useState(false);
    const [flagSSODialog, setFlagSSODialog] = useState(false);
    const [flagCredentialDialog, setFlagCredentialDialog] = useState(false);

    const [currentTab, setCurrentTab] = useState<any>("information");
    const [keyIndicesCurrentTab, setKeyIndicesCurrentTab] = useState("Indices");
    const [showAppName, setShowAppName] = useState<any>(null);
    const [showAppId, setShowAppId] = useState<number | null>(null);
    const [showAppStatus, setShowAppStatus] = useState<string | null>(null);
    const [radtailLinkData, setRadtailLinkData] = useState<any>([]);
    const [acrylicTeamListData, setAcrylicTeamListData] = useState<any>([]);
    const [currentAppUrl, setCurrentAppUrl] = useState<any>("");
    const [storedBase64URL, setStoredBase64URL] = useState<any>(null);

    // DATA STORED
    const [featuredAppData, setFeaturedAppData] = useState<any[] | null>(null)
    const [installedAppsData, setInstalledAppsData] = useState<any>(null)
    const [categorizedApps, setCategorizedApps] = useState<any>({});
    const [tabs, setTabs] = useState<any[]>([]);
    const [multiRedirectDialogData, setMultiRedirectDialogData] = useState<any[] | null>([])
    const [draggingIndex, setDraggingIndex] = useState<number | null>(null);


    const initializeAcrylicTeamListAuth = async (userId: number | null = null) => {
        let payloadQuery = "";

        if (isProfileAdmin) {
            // Admin: always pass flagGetAll=false and userId
            payloadQuery = `flagGetAll=false&assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        } else {
            // Non-admin: pass only assignedToUserId
            payloadQuery = `assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        }

        setFlagLoader(true);
        const response = await agent.getAcrylicTeamMemberDashboardApi.get(payloadQuery);
        console.log("response of getAcrylicTeamMemberApi", response);

        if (response?.status && response?.data) {
            setAcrylicTeamListData(response.data);
            setFlagLoader(false);
        }
        else {
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    };

    useEffect(() => {
        initializeAcrylicTeamListAuth()
        fetchSymoboleDetails()
    }, [])

    useEffect(() => {
        if (!dashboardDetails || !dashboardDetails.apps) return;

        // Filter installed apps (excluding "Revenue App")
        const installedApps = dashboardDetails.apps?.sort((a, b) => (a.appOrder || 0) - (b.appOrder || 0));
        setInstalledAppsData(installedApps);

        // If categorization is no longer needed, we can skip setTabs & setCategorizedApps
        const directCategorizedData = {
            all: installedApps?.map(app => ({
                appId: app.appId,
                appName: app.appName,
                image: app.image,
                featureImage: app.featureImage,
                redirectUrls: app.redirectUrl?.map(urlObj => ({
                    icon: urlObj.icon,
                    title: urlObj.title,
                    url: urlObj.url,
                })),
                flagAccess: app.flagAccess,
                status: app.status
            }))
        };

        setTabs([{ label: "All", value: "all" }]);
        setCategorizedApps(directCategorizedData);
    }, [dashboardDetails]);

    useEffect(() => {
        // Check if the script already exists
        const scriptId = "tradingview-widget-script";
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
            script.async = true;

            script.innerHTML = JSON.stringify({
                colorTheme: "dark",
                dateRange: "12M",
                showChart: false,
                locale: "en",
                largeChartUrl: "",
                isTransparent: true,
                showSymbolLogo: true,
                showFloatingTooltip: false,
                width: "100%",
                height: "100%",
                scaleFontColor: "#ffffff", // Axis and text colors
                symbolActiveColor: "rgba(41, 98, 255, 0.5)", // Highlight color
                plotLineColorGrowing: "#00ff00", // Growing line (green)
                tabs: [
                    {
                        title: "Indices",
                        symbols: [
                            { s: "FOREXCOM:SPXUSD", d: "S&P 500 Index" },
                            { s: "FOREXCOM:NSXUSD", d: "Nasdaq 100" },
                            { s: "FOREXCOM:DJI", d: "Dow Jones Industrial Average" },
                            { s: "INDEX:NKY", d: "Nikkei 225" },
                            { s: "INDEX:DEU40", d: "DAX Index" },
                            { s: "FOREXCOM:UKXGBP", d: "FTSE 100" },
                        ],
                        originalTitle: "Indices",
                    },
                    {
                        title: "Futures",
                        symbols: [
                            { s: "CME_MINI:ES1!", d: "S&P 500" },
                            { s: "CME:6E1!", d: "Euro" },
                            { s: "COMEX:GC1!", d: "Gold" },
                            { s: "NYMEX:CL1!", d: "WTI Crude Oil" },
                            { s: "NYMEX:NG1!", d: "Gas" },
                            { s: "CBOT:ZC1!", d: "Corn" },
                        ],
                        originalTitle: "Futures",
                    },
                    {
                        title: "Bonds",
                        symbols: [
                            { s: "CBOT:ZB1!", d: "T-Bond" },
                            { s: "CBOT:UB1!", d: "Ultra T-Bond" },
                            { s: "EUREX:FGBL1!", d: "Euro Bund" },
                            { s: "EUREX:FBTP1!", d: "Euro BTP" },
                            { s: "EUREX:FGBM1!", d: "Euro BOBL" },
                        ],
                        originalTitle: "Bonds",
                    },
                    {
                        title: "Forex",
                        symbols: [
                            { s: "FX:EURUSD", d: "EUR to USD" },
                            { s: "FX:GBPUSD", d: "GBP to USD" },
                            { s: "FX:USDJPY", d: "USD to JPY" },
                            { s: "FX:USDCHF", d: "USD to CHF" },
                            { s: "FX:AUDUSD", d: "AUD to USD" },
                            { s: "FX:USDCAD", d: "USD to CAD" },
                        ],
                        originalTitle: "Forex",
                    },
                ],
            });

            if (containerRef.current) {
                containerRef.current.appendChild(script);
            }
        }
    }, []);

    const fetchSymoboleDetails = async () => {
        setFlagLoader(true)
        const response = await agent?.getUserStocksSymboleDetails.get()
        console.log("response of getUserStocksSymboleDetails", response);

        if (response?.status) {
            setFlagLoader(false)
            const { stocks, customizationOptions } = response.data || {};

            const capitalizeFirstLetter = (str: string) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
            const selected = stocks.map((s: any) => ({
                label: `${s.stockSymbol} - ${s.stockTitle}`,
                value: s.stockId,
            }));
            const filteroutTheme = storedColorthemeOptions?.backgroundColors?.find((ele: any) => ele.name?.toLowerCase() == customizationOptions?.colorTheme?.toLowerCase())

            setSelectedStocks(selected);
            setTickerSaveDetailsDsh((prev: any) => ({
                ...prev,
                stockIds: selected?.map((s: any) => s.value),
                stokesDetails: stocks,
                customizationOptions: {
                    ...prev.customizationOptions,
                    bgColor: filteroutTheme?.hex ?? 'black',
                    colorTheme: capitalizeFirstLetter(filteroutTheme?.theme ?? ''),
                    displayMode: capitalizeFirstLetter(customizationOptions?.displayMode ?? ''),
                    isLogoVisible: customizationOptions?.isLogoVisible ?? false,
                },
            }));
        }
        else {
            setFlagLoader(false)
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    }
    // USE EFFECT : BFR USER APP STATUS -----
    // useEffect(() => {
    //     if (!dashboardDetails || !dashboardDetails.apps) return;

    //     // Filter apps that are not installed and sort by appOrder
    //     const appNotInstalledFilterData = dashboardDetails?.apps?.filter((item) => item.flagInstalled == false)?.sort((a, b) => a.appOrder - b.appOrder);
    //     setFeaturedAppData(appNotInstalledFilterData);

    //     // Filter apps where flagInstalled is true
    //     const installedApps = dashboardDetails?.apps?.filter((item) => item.flagInstalled === true && item.appName?.trim()?.toLowerCase() !== "revenue app")
    //     setInstalledAppsData(installedApps)

    //     // Process the apps data to categorize
    //     const sections = Array.from(new Set(dashboardDetails?.apps?.map((app) => app.appSection)));

    //     const newTabs = sections.map((section) => ({
    //         label: section,
    //         value: section.toLowerCase().replace(/\s+/g, "-"),
    //     }));

    //     const categorizedData = sections.reduce((acc: any, section: any) => {
    //         acc[section.toLowerCase().replace(/\s+/g, "-")] = installedApps.filter((app: any) => app.appSection === section).sort((a: any, b: any) => a.appOrder - b.appOrder)
    //             .map((app: any) => ({
    //                 appId: app.appId,
    //                 appName: app.appName,
    //                 image: `${baseURL}${app.image}`,
    //                 redirectUrls: app.redirectUrl.map((urlObj: any) => ({
    //                     icon: urlObj.icon,
    //                     title: urlObj.title,
    //                     url: urlObj.url,
    //                 })),
    //                 flagAccess: app.flagAccess,
    //                 status: app.status
    //             }));
    //         return acc;
    //     }, {});

    //     setTabs(newTabs);
    //     setCategorizedApps(categorizedData);
    // }, [dashboardDetails]);


    // USE EFFECT -----

    // HANDLE FUNCTION
    const handleSort = async () => {
        if (dragItem.current === null || dragOverItem.current === null) return;

        previousAppsData.current = [...installedAppsData];

        const reordered = [...installedAppsData];
        const draggedItem = reordered.splice(dragItem.current, 1)[0];

        reordered.splice(dragOverItem.current, 0, draggedItem);
        const updated = reordered.map((app, index) => ({ ...app, appOrder: index + 1 }));
        setInstalledAppsData(updated);

        const payload: AppsOrderPayload = {
            appsOrder: updated?.map((app) => ({
                appId: app.appId,
                appOrderNo: app.appOrder ?? 0
            })),
        };

        const response = await agent.changeAppOrderApi.put(payload);
        if (response?.status) {
            console.log("Logs changeAppOrderApi:", response);
        }
        else {
            setInstalledAppsData(previousAppsData.current || []);
            // const errorMessage = response?.error?.message || 'Something Went Wrong!';
            // showSnackbar(errorMessage, 'error');
        }
        // Reset drag refs
        dragItem.current = null;
        dragOverItem.current = null;
        setDraggingIndex(null);
    };


    const handleTabChange = (newValue: string) => {
        setCurrentTab(newValue);
    };

    const handleKeyIndicesTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setKeyIndicesCurrentTab(newValue);
    };

    const getRedtailSSO = async (baseURL: any = "dashboard") => {
        try {
            const response = await fetch(`https://api2.redtailtechnology.com/crm/v1/rest/sso?ep=${baseURL}`, {
                method: 'GET',
                headers: {
                    'Authorization': `userkeyauth ${storedBase64URL}`,
                    'Accept': 'application/xml',
                }
            });

            const data = await response.text();

            if (data) {
                var xml = new XMLParser().parseFromString(data);
                let returnURL = xml.children?.find((child: any) => child.name === "ReturnURL")?.value;
                returnURL = returnURL.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                if (returnURL && /^https?:\/\/[^ "]+$/.test(returnURL)) {
                    window.open(returnURL, '_blank');
                    setFlagSSODialog(false)
                    setStoredBase64URL(null)
                }
                else {
                    const errorMessage = xml.children?.find((child: any) => child.name === "Message")?.value || "Something went wrong!";
                    showSnackbar(errorMessage, "error");
                    setStoredBase64URL(null)
                    // throw new Error("Something Went Wrong!");
                }
            }
        } catch (err) {
            console.error("Something went wrong", err);
            console.log("catch errors", err);
            const errorMessage = err instanceof Error ? err.message : "Something went wrong!";
            showSnackbar(errorMessage, "error");

        }
    };

    const getBrokersAllianceSSO = async () => {
        setFlagLoader(true)
        const response = await agent.getBrokersAllianceSSOAPI.get()
        if (response?.status) {
            const navigateLink = response?.url
            window.open(navigateLink, "_blank")
            setFlagLoader(false)
        }
        else {
            const errorMessage = "Something went wrong!";
            showSnackbar(errorMessage, "error");
            setFlagLoader(false)
        }
    }

    const getLifeBrainSSO = async () => {
        setFlagLoader(true)
        const response = await agent.getLifeBrainSSOAPI.get()
        if (response?.status) {
            const navigateLink = response?.url
            setFlagLoader(false)
            window.open(navigateLink, "_blank")
        }
        else {
            const errorMessage = "Something went wrong!";
            showSnackbar(errorMessage, "error");
            setFlagLoader(false)
        }
    }

    const getRetirementBrainSSO = async () => {
        setFlagLoader(true)
        const response = await agent.getRetirementBrainSSOAPI.get()
        if (response?.status) {
            const navigateLink = response?.url
            window.open(navigateLink, "_blank")
            setFlagLoader(false)
        }
        else {
            const errorMessage = response?.error?.message;
            showSnackbar(errorMessage, "error");
            setFlagLoader(false)
        }
    }

    const getBrooklightSSO = async () => {
        setFlagLoader(true)
        const response = await agent.getBrooklightSSOAPI.get()
        if (response?.status) {
            const navigateLink = response?.url
            window.open(navigateLink, "_blank")
            setFlagLoader(false)
        }
        else {
            const errorMessage = "Something went wrong!";
            showSnackbar(errorMessage, "error");
            setFlagLoader(false)
        }
    }

    const handleApps = async (event: React.MouseEvent<HTMLElement>, ele: any) => {
        event.preventDefault();
        setShowAppName(ele);
        if (!ele.flagAccess) {
            setFlagAccessDialog(true);
            setShowAppName(ele);
            return;
        }

        const redirectUrls = ele.redirectUrl || [];
        const filterAppNameId = Number(ele.appId)
        const appName = ele.appName?.trim()?.toLowerCase();

        if (filterAppNameId == 1) {
            try {
                setFlagLoader(true);
                const response: any = await agent.getRedTailSsoAPI.get()
                console.log("response of getRedTailSsoAPI", response);

                if (response?.status) {
                    console.log('SSO API call successful:', response);
                    const base64 = response?.data?.userKey;
                    setFlagLoader(false);
                    setFlagSSODialog(true)
                    setStoredBase64URL(base64)
                    setRadtailLinkData(redirectUrls)
                    // await getRedtailSSO(base64)
                    return;
                }
                else if (response.data?.flagValid == false) {
                    setFlagSSODialog(false)
                    setFlagCredentialDialog(true)
                    setFlagLoader(false);
                }
                else {
                    setFlagLoader(false);
                    const showError = response?.error.message ? response?.error.message : ""
                    showSnackbar(showError, "error");
                    console.error('SSO API response status indicates failure:', response);
                }
            }
            catch (error) {
                setFlagLoader(false);
                console.error('Error hitting API:', error);
                showSnackbar("Something Went Wrong!", "error");
            }
        }

        if (filterAppNameId == 2) {
            getBrokersAllianceSSO()
            return
        }

        if (filterAppNameId == 3) {
            getLifeBrainSSO()
            return
        }

        if (filterAppNameId == 4) {
            getRetirementBrainSSO()
            return
        }

        if (filterAppNameId == 10) {
            getBrooklightSSO()
            return
        }

        if (filterAppNameId == 7) {
            navigate("/dashboard/marketing-and-sales");
            return
        }

        if (filterAppNameId == 8) {
            navigate("/dashboard/401k-fee-comparison");
            return;
        }

        if (redirectUrls.length > 1 && filterAppNameId != 1) {
            setMultiRedirectDialogData(redirectUrls);
            setFlagClientMarketingDialog(true);
            return;
        }

        if (redirectUrls.length === 1) {
            window.open(redirectUrls[0]?.url, "_blank");
            return;
        }

        // if (appName === "revenue app") {
        //     navigate("/dashboard/revenue");
        //     return;
        // }
    };

    // HANDLE FUNCTION
    // const handleAppAccessRequest = async () => {
    //     setFlagLoader(true)
    //     setFlagAccessDialog(false)
    //     setFlagAppStoreDialog(false)
    //     try {
    //         const payload: AppAccessRequestInterface = {
    //             app_id: showAppId
    //         }
    //         const response = await agent.appAccessRequestApi.post(payload)
    //         if (response.status) {
    //             showSnackbar(response.message ? response.message : "Request for app access has sent to admin", 'success')
    //             const userDetailsResponse = await userDetails();
    //             if (userDetailsResponse?.status && userDetailsResponse?.data) {
    //                 const userMeResponse = userDetailsResponse.data
    //                 setUserProfileDetails({
    //                     ...userProfileDetails,
    //                     flagLoggedIn: true,
    //                     user: userDetailsResponse.data.user,
    //                     accessToken: userDetailsResponse.data.accessToken,
    //                     apps: userDetailsResponse.data.apps
    //                 });
    //                 if (userMeResponse.apps) {
    //                     setDashboardDetails({ apps: userMeResponse.apps });
    //                 }
    //                 setFlagLoader(false);
    //             }
    //             else {
    //                 setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
    //                 setFlagLoader(false);
    //             }
    //         } else {
    //             console.log("error in response", response);
    //             showSnackbar(response.error.message, 'error')
    //             setFlagLoader(false)
    //         }
    //     }
    //     catch (error) {
    //         setFlagLoader(false)
    //         console.error("Error during app access request", error);
    //         showSnackbar("Something Went Wrong!", 'error')
    //     }
    // }

    // const handleAppInstall = async () => {
    //     setFlagLoader(true)
    //     setFlagInstallAccessDialog(false)
    //     setFlagAppStoreDialog(false)
    //     try {
    //         const payload: AppAccessRequestInterface = {
    //             app_id: showAppId
    //         }
    //         const response = await agent.appInstallApi.post(payload)
    //         // console.log("app-install-request", response)
    //         if (response.status) {
    //             showSnackbar(response.message ? response.message : "App installed successfully", 'success')
    //             const userDetailsResponse = await userDetails();
    //             if (userDetailsResponse?.status && userDetailsResponse?.data) {
    //                 const userMeResponse = userDetailsResponse.data
    //                 setUserProfileDetails({
    //                     ...userProfileDetails,
    //                     flagLoggedIn: true,
    //                     user: userDetailsResponse.data.user,
    //                     accessToken: userDetailsResponse.data.accessToken,
    //                     apps: userDetailsResponse.data.apps
    //                 });
    //                 if (userMeResponse.apps) {
    //                     setDashboardDetails({ apps: userMeResponse.apps });
    //                 }
    //                 setFlagLoader(false);
    //             }
    //             else {
    //                 setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
    //                 setFlagLoader(false);
    //             }
    //         } else {
    //             console.log("error in response", response);
    //             showSnackbar(response.error.message, 'error')
    //             setFlagLoader(false)
    //         }
    //     }
    //     catch (error) {
    //         setFlagLoader(false)
    //         console.error("Error during app install", error);
    //         showSnackbar("Something Went Wrong!", 'error')
    //     }
    // }

    return (
        <>
            {flagOpenKeyIndeciesDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="lg"
                    dialogHead="Key Indices"
                    open={flagOpenKeyIndeciesDialog}
                    view={
                        <KeyIndecesDialog
                            keyIndicesTabs={keyIndicesTabs}
                            keyIndicesCurrentTab={keyIndicesCurrentTab}
                            handleKeyIndicesTabChange={handleKeyIndicesTabChange}
                            keyIndicesData={keyIndicesData}
                            flagOpenKeyIndeciesDialog={flagOpenKeyIndeciesDialog}
                        />
                    }
                    onClose={() => { setFlagOpenKeyIndeciesDialog(false) }}
                />
            }

            {flagClientMarketingDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead={showAppName.appName ? showAppName.appName : ""}
                    open={flagClientMarketingDialog}
                    view={
                        <AppClientMarketingDialog
                            setFlagClientMarketingDialog={setFlagClientMarketingDialog}
                            multiRedirectDialogData={multiRedirectDialogData}
                        />
                    }
                    onClose={() => { setFlagClientMarketingDialog(false) }}
                />
            }

            {flagSSODialog &&
                <Dialog
                    open={flagSSODialog}
                    maxWidth={"md"}
                    onClose={() => { setFlagSSODialog(false) }}
                    sx={{
                        "& .MuiPaper-root": {
                            background: "#273348",
                            padding: isBelow600 ? "15px" : '20px',
                            margin: isBelow600 ? "15px" : "32px"
                        }

                    }}
                    className={styles.standaloneDialogStyles}
                >
                    <ClientMarketingAndCorrespondenceDialog
                        headerName={"Redtail"}
                        flagSSODialog={flagSSODialog}
                        setFlagSSODialog={setFlagSSODialog}

                        radtailLinkData={radtailLinkData}
                        setCurrentAppUrl={setCurrentAppUrl}

                        getRedtailSSO={getRedtailSSO}
                        showAppName={showAppName}

                        setFlagCredentialDialog={setFlagCredentialDialog}
                    />
                </Dialog>
            }

            {flagCredentialDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="sm"
                    dialogHead="Updated Redtail Credentials"
                    open={flagCredentialDialog}
                    view={
                        <CredentialsDialog
                            flagCredentialDialog={flagCredentialDialog}
                            setFlagCredentialDialog={setFlagCredentialDialog}
                            getRedtailSSO={getRedtailSSO}
                            setCurrentAppUrl={setCurrentAppUrl}
                        />
                    }
                    onClose={() => { setFlagCredentialDialog(false) }}
                />
            }


            {/* {flagSSODialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead={showAppName.appName ? showAppName.appName : ""}
                    open={flagSSODialog}
                    view={
                        <SsoDialog
                            setFlagSSODialog={setFlagSSODialog}
                            currentAppUrl={currentAppUrl}
                            setCurrentAppUrl={setCurrentAppUrl}
                            radtailLinkData={radtailLinkData}
                            getRedtailSSO={getRedtailSSO}
                        />
                    }
                    child={
                        <Grid container sx={{ gap: "5px" }}>
                            <Grid size={{ xs: 12 }} display="flex" alignItems={"center"} marginRight={"10px"}>
                                <Grid container display="flex" alignItems={"center"}>
                                    <Typography
                                        component={'span'}
                                        className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV14}`}
                                    >
                                        Status
                                    </Typography>
                                    <Typography
                                        component={'span'}
                                        className={`${globalStyles.globalTextV14}`}
                                        sx={{ color: showAppName.status == "Active" ? "green" : "White" }}
                                    >
                                        :&nbsp;{showAppName.status}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: "auto" }}>
                                <GlobalButton
                                    value='Update Redtail Credentials'
                                    size={"medium"}
                                    className={styles.updateCredButton}
                                    onClick={() => {
                                        setFlagCredentialDialog(true);
                                        setFlagSSODialog(false)
                                    }}
                                />
                            </Grid>
                        </Grid>
                    }
                    onClose={() => { setFlagSSODialog(false) }}
                />
            } */}


            {/*
            ****************  AFTER REMOVE FEATURED APP ***************
            {flagAppStoreDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="lg"
                    dialogHead="App Store"
                    open={flagAppStoreDialog}
                    view={
                        <AppStores
                            accessDialog={accessDialog}
                            setFlagAccessDialog={setFlagAccessDialog}

                            flagInstallAccessDialog={flagInstallAccessDialog}
                            setFlagInstallAccessDialog={setFlagInstallAccessDialog}

                            setShowAppName={setShowAppName}
                            setShowAppId={setShowAppId}
                            setShowAppStatus={setShowAppStatus}
                        />
                    }
                    onClose={() => { setFlagAppStoreDialog(false) }}
                />
            }

            {accessDialog && (
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="sm"
                    dialogHead={showAppName ? showAppName : ""}
                    open={accessDialog}
                    view={
                        <GlobalWarningDialog
                            popupDescription={showAppStatus === 'Under Process' ? "You have already Requested to access this app." : "This is a restricted app. You would need Permission to Access this App."}
                            primaryButtonText={showAppStatus === 'Under Process' ? null : "Request For Access"}
                            secondaryButtonText={"Close"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleAppAccessRequest}
                            handleClose={() => { setFlagAccessDialog(false) }}
                        />
                    }
                    onClose={() => { setFlagAccessDialog(false) }}
                />
            )}

            {flagInstallAccessDialog && (
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="sm"
                    dialogHead={showAppName ? showAppName : ""}
                    open={flagInstallAccessDialog}
                    view={
                        <GlobalWarningDialog
                            popupDescription={"Are you sure you want to Install this App?"}
                            primaryButtonText={"Install"}
                            secondaryButtonText={"Close"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleAppInstall}
                            handleClose={() => { setFlagInstallAccessDialog(false) }}
                        />
                    }
                    onClose={() => { setFlagInstallAccessDialog(false) }}
                />
            )} 
            ****************  AFTER REMOVE FEATURED APP *************** 
            */}


            {!isBelow1200 && <AppNavbar />}
            {flagPortfolioDialog && (
                <GlobalDialog
                    open={flagPortfolioDialog}
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead="Portfolio"
                    view={
                        <PortfolioDialog />
                    }
                    onClose={() => { setFlagPortfolioDialog(false) }}
                />
            )}

            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px" }}>
                    <Grid container >
                        <Grid size={{ xs: 12 }} className={`${styles.dashboardMarqueMainItem}`}>
                            <StocksMarquee />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Grid container sx={{ justifyContent: 'space-between', }}>
                                <Grid size={{ xl: 8.45, lg: 8, md: 12, sm: 12, xs: 12 }} className={`${styles.dashboardLeftSection}`} >
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsFeatureSectionItem} `}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${styles.dsCardHeadItem}`}>
                                                    <Typography component={'span'} className={`${isBelow600 ? globalStyles.globalTextV18 : globalStyles.globalHeadV2} ${globalStyles.gblCWhite}`}>
                                                        My Apps
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12 }} >
                                                    <Grid container className={`${styles.featureCardContainer}`}>
                                                        {installedAppsData && installedAppsData.length && installedAppsData?.map((ele: any, index: number) => {
                                                            const image = ele.image;
                                                            return (
                                                                <>
                                                                    <Grid
                                                                        key={index}
                                                                        // className={`${styles.featureCardAppsItem} ${draggingIndex == index ? styles.dragging : ''}`}
                                                                        className={`
                                                                            ${styles.featureCardAppsItem}
                                                                            ${ele.status == "Disabled" ? styles.featureCardAppsDisableItem : ''}
                                                                            ${draggingIndex == index ? styles.dragging : styles['animate-move']}
                                                                          `}
                                                                        sx={{ padding: "10px 0px" }}
                                                                        draggable
                                                                        onDragStart={() => {
                                                                            dragItem.current = index;
                                                                            setDraggingIndex(index);
                                                                        }}
                                                                        onDragEnter={() => (dragOverItem.current = index)}
                                                                        onDragEnd={() => {
                                                                            handleSort();
                                                                            setDraggingIndex(null);
                                                                        }}
                                                                        onDragOver={(e) => e.preventDefault()}
                                                                    >
                                                                        {(ele.appId === 15 || ele.appName === 'Orion Advisor Solutions') ?
                                                                            <Tooltip
                                                                                title={
                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                                        <Icons iconName="warning-icon" iconWidth="35px" iconHeight="35px" />
                                                                                        If you see an error screen, please check with your Orion administrator to ensure your account is active.
                                                                                    </div>
                                                                                }
                                                                                placement='top'
                                                                                arrow
                                                                                slotProps={{
                                                                                    popper: {
                                                                                        modifiers: [
                                                                                            {
                                                                                                name: 'offset',
                                                                                                options: {
                                                                                                    offset: [0, -10],
                                                                                                },
                                                                                            },
                                                                                        ],
                                                                                    },
                                                                                    tooltip: {
                                                                                        sx: {
                                                                                            backgroundColor: '#3F5374',
                                                                                            color: '#fff',
                                                                                            fontSize: '12px',
                                                                                            padding: '8px 12px',
                                                                                            borderRadius: '5px',
                                                                                            maxWidth: 330
                                                                                        },
                                                                                    },
                                                                                    arrow: {
                                                                                        sx: {
                                                                                            color: '#3F5374',
                                                                                        },
                                                                                    }
                                                                                }}>
                                                                                <span tabIndex={0}>
                                                                                    <FeaturedCards
                                                                                        featureName={ele.appName}
                                                                                        featureImg={image}
                                                                                        featureStatus={ele.status}
                                                                                        featureStyling={{
                                                                                            fontSize: "15px",
                                                                                            fontWeight: "500",
                                                                                        }}
                                                                                        onClick={(event: any) => {
                                                                                            if (ele.status !== "Disabled") {
                                                                                                handleApps(event, ele);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                                            :
                                                                            <FeaturedCards
                                                                                featureName={ele.appName}
                                                                                featureStatus={ele.status}
                                                                                featureImg={image}
                                                                                featureStyling={{
                                                                                    fontSize: "15px",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                                onClick={(event: any) => {
                                                                                    if (ele.status !== "Disabled") {
                                                                                        handleApps(event, ele);
                                                                                    }
                                                                                }}
                                                                            />}
                                                                    </Grid>
                                                                </>
                                                            )
                                                        })}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsPorfolioCards} ${styles.dsGlobalCardStyles}`}>
                                            <Grid container className={`${styles.dsPortfolioSectionContainer}`} >
                                                <Grid size={{ xs: 12 }} className={`${styles.dsPortfolioSectionItem}`}>
                                                    <Grid container sx={{ justifyContent: "space-between", gap: "10px", height: '100%' }}>
                                                        <Grid size={{ xs: "grow" }}>
                                                            <Typography
                                                                component='span'
                                                                className={`${isBelow600 ? globalStyles.globalTextV18 : globalStyles.globalHeadV2} ${globalStyles.gblCWhite}`}
                                                            >
                                                                Portfolio
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: "auto" }} sx={{ textAlign: 'end' }}>
                                                            <GlobalButton
                                                                value='Add Portfolio'
                                                                className={`${globalStyles.globleButtonStyleV1}`}
                                                                onClick={() => { setFlagPortfolioDialog(true) }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12 }} className={`${styles.dsPortfolioSectionContentItem}`}>
                                                    <Typography component={'span'} className={`${globalStyles.globalHeadV1}`}>
                                                        No portfolio has been created yet.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/**********************
                                         ****************  AFTER REMOVE FEATURED APP *************** 
                                         *  <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsGlobalCardStyles}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }}>
                                                    <Grid container>
                                                        <Grid size={{ xs: "grow" }} className={`${styles.dsCardHeadItem}`}>
                                                            <Typography component={'span'} className={`${isBelow600 ? globalStyles.globalTextV18 : globalStyles.globalHeadV2} ${globalStyles.gblCWhite}`}>
                                                                Featured Apps
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: "auto" }} sx={{ textAlign: 'end' }}>
                                                            <GlobalButton
                                                                value='View App Store'
                                                                className={`${globalStyles.globleButtonStyleV1}`}
                                                                onClick={() => { setFlagAppStoreDialog(true) }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid size={{ xs: 12 }} >
                                                    <Grid container className={`${styles.featureCardContainer}`}>
                                                        {featuredAppData && featuredAppData?.map((ele: any, index: number) => {
                                                            const image = baseURL + ele.image;
                                                            return (
                                                                <Grid
                                                                    key={index}
                                                                    className={ele.status === "Disabled" ? `${styles.featureCardAppsDisableItem}` : `${styles.featureCardAppsItem}`}
                                                                    sx={{ padding: "10px 0px" }}
                                                                >
                                                                    <Grid container>
                                                                        <FeaturedCards
                                                                            featureName={ele.appName}
                                                                            featureImg={image || ""}
                                                                            featureStatus={ele.status}
                                                                            featureStyling={{
                                                                                fontSize: "15px",
                                                                                fontWeight: "500",
                                                                            }}
                                                                            onClick={
                                                                                ele.status !== "Disabled"
                                                                                    ? () => {
                                                                                        setShowAppName(ele.appName);
                                                                                        setShowAppId(ele.appId);
                                                                                        setShowAppStatus(ele.status);
                                                                                        // if (!ele.flagAccess) {
                                                                                        //     setFlagAccessDialog(true);
                                                                                        //     return;
                                                                                        // }
                                                                                        // if (!ele.flagInstalled) {
                                                                                        //     setFlagInstallAccessDialog(true);
                                                                                        //     return;
                                                                                        // }
                                                                                    }
                                                                                    : undefined
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid> 
                                        ****************  AFTER REMOVE FEATURED APP *************** 
                                        ***********************/}
                                    </Grid>
                                </Grid>

                                <Grid size={{ xl: 3.45, lg: 3.8, md: 12, sm: 12, xs: 12 }} className={`${styles.dashboardRightSection}`}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }}>
                                            <AcrylicTeamProfilelist acrylicTeamListData={acrylicTeamListData} />
                                        </Grid>


                                        <Grid size={{ xs: 12 }} className={`${styles.lifebrainItem} ${styles.dsFeatureSectionItem} `}>
                                            <img
                                                src={lifebrain}
                                                alt=""
                                                style={{ width: "100%", height: '100%' }}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsGlobalCardStyles}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 10px" }}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 6 }}>
                                                            <Typography component={'span'} className={`${isBelow600 ? globalStyles.globalTextV18 : globalStyles.globalHeadV2} ${globalStyles.gblCWhite}`}>
                                                                Key Indices
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 6 }} sx={{ textAlign: 'end' }}>
                                                            <GlobalButton
                                                                value='Full View'
                                                                className={`${globalStyles.globleButtonStyleV1}`}
                                                                onClick={() => {
                                                                    setFlagOpenKeyIndeciesDialog(true)
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid size={{ xs: 12 }} className={`${styles.keyIndicesValueitem}`}>
                                                    <Grid container sx={{ height: "100%" }}>
                                                        <div className="tradingview-widget-container" ref={containerRef}>
                                                            <div className="tradingview-widget-container__widget">
                                                            </div>
                                                            <div className="tradingview-widget-copyright" style={{ margin: '5px 0px 0px' }}>
                                                                <a
                                                                    href="https://www.tradingview.com/"
                                                                    rel="noopener nofollow"
                                                                    target="_blank"
                                                                >
                                                                    <Typography component={'span'} className={`${globalStyles.gblC00B7FF} ${globalStyles.globalTextV16}`}>
                                                                        Market Data&nbsp;
                                                                    </Typography>
                                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}>
                                                                        by Trading View
                                                                    </Typography>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        </Grid>

                                        <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsGlobalCardStyles} `}>
                                            <Typography component={'span'} className={`${globalStyles.globalTextV18} ${globalStyles.gblCWhite}`}>
                                                Schwab Advisor Center (coming soon)
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ textAlign: 'center', margin: '10px 0px' }}>
                            <img
                                src={varifiedLogo}
                                alt=""
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <ComplianceDocument />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}